import React, { useEffect } from 'react';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import { TextButton } from '@hcs/design-system';
import { Input } from '@hcs/design-system';
import { Dialog } from '@hcs/design-system';
import { MenuItem } from '@hcs/design-system';
import { OmFileIcon } from '@hcs/design-system';
import { useActiveState } from '@hcs/hooks';
import { usePatchReportPreferencesForOrg } from '@hcs/huell';
import { useReportPreferencesForOrg } from '@hcs/huell';

import styles from './OrgReportPreferences.module.css';

interface WebhookFormData {
  url: string;
}

const DESCRIPTION =
  'Receive updates via webhook when reports are created and updated.';
const dataHcName = 'default-valuation-method-control';
export const WebhookSettingsControl = () => {
  const { active, handleOpen, handleClose } = useActiveState();
  const { isSuccess, data: orgReportPrefs } = useReportPreferencesForOrg();
  const { mutate: patchOrgPrefs } = usePatchReportPreferencesForOrg();
  const currentPreferenceValue = orgReportPrefs?.preferences?.webhookUrl || '';
  const isSetup = isSuccess && currentPreferenceValue;
  const form = useForm<WebhookFormData>({
    resolver: yupResolver(
      yup.object().shape({
        url: yup.string().url().required(),
      })
    ),
    mode: 'onBlur',
    reValidateMode: 'onChange',
    defaultValues: {
      url: currentPreferenceValue,
    },
  });

  useEffect(() => {
    form.setValue('url', currentPreferenceValue);
  }, [currentPreferenceValue, form]);

  const handleCancel = () => {
    form.reset();
    handleClose();
  };

  const handleSubmit = () => {
    const path = `/webhookUrl`;
    const url = form.getValues().url;
    if (url) {
      patchOrgPrefs([
        {
          op: 'add',
          path,
          value: url,
        },
      ]);
    } else {
      patchOrgPrefs([
        {
          op: 'remove',
          path,
        },
      ]);
    }
    handleClose();
  };
  console.log('disabled', !form.formState.isDirty, !form.formState.isValid);
  return (
    <>
      <MenuItem
        dataHcName={dataHcName}
        Icon={OmFileIcon}
        label="Webhook"
        description={DESCRIPTION}
        contentRight={
          <div className={styles.SwitchLabel}>
            <TextButton
              dataHcName={`${dataHcName}-edit`}
              onClick={handleOpen}
              label={isSetup ? 'Change URL' : 'Setup'}
            />
          </div>
        }
      />
      <FormProvider {...form}>
        <form data-hc-name={`${dataHcName}-form`}>
          <Dialog
            dataHcName={`${dataHcName}-dialog`}
            active={active}
            onClose={handleClose}
            title={isSetup ? 'Change Webhook URL' : 'Setup Webhook'}
            subtitle={DESCRIPTION}
            type="small"
            actions={[
              {
                dataHcName: `${dataHcName}-cancel`,
                label: 'Cancel',
                secondary: true,
                onClick: handleCancel,
              },
              {
                dataHcName: `${dataHcName}-save`,
                label: 'Save',
                disabled: !form.formState.isDirty || !form.formState.isValid,
                onClick: form.handleSubmit(handleSubmit),
              },
            ]}
          >
            <div style={{ height: '250px' }}>
              <label>Webhook URL:</label>
              <Controller
                name="url"
                control={form.control}
                render={({ field, fieldState }) => {
                  return (
                    <Input
                      {...field}
                      error={fieldState.error?.message}
                      dataHcName={`${dataHcName}-url-input`}
                    />
                  );
                }}
              />
            </div>
          </Dialog>
        </form>
      </FormProvider>
    </>
  );
};
